import React from 'react';
import Button from '@raydiant/raydial/components/Button';
import { ArrowLeft } from '@raydiant/raydial/components/Icons';
import Text from '@raydiant/raydial/components/Text';
import Card from '@raydiant/raydial/components/Card';
import Divider from '@raydiant/raydial/components/Divider';
import cn from 'classnames';

interface CheckoutPageLayoutProps {
  className?: string;
  onGoBack?: () => void;
  children: React.ReactNode;
}

const CheckoutPageLayout = ({
  onGoBack,
  children,
  className,
}: CheckoutPageLayoutProps) => {
  return (
    <Card
      className={cn(
        'w-full min-h-[calc(100vh-240px)] p-8 flex flex-col max-w-[1056px]',
        className,
      )}
    >
      <div>
        <div className="flex text-black gap-2 items-center">
          {onGoBack && (
            <Button variant="unstyled" onPress={onGoBack}>
              <ArrowLeft size={20} />
            </Button>
          )}

          <Text variant="subheader" className="text-black">
            Checkout
          </Text>
        </div>
      </div>
      <Divider className="border-[#D9D9D9] my-4" />
      {children}
    </Card>
  );
};

export default CheckoutPageLayout;
